import axios from 'axios'
import { notificationDangerCustomTime } from '../../../utils/customToastify'
import { SET_PAYMENT_DATA, GET_TABLE_DATA, CLEAR_PAYMENT_DATA } from './types'

export const getReferalTableData = (options) => async (dispatch) => {
  // const reponse = await axios.get('/referral', { params: { ...options } })
  const reponse = await axios.get('/referral/get-referrals', { params: { ...options } })
  dispatch({
    type: GET_TABLE_DATA,
    payload: { data: reponse.data, options },
  })
}

export const setPaymentData = (data) => async (dispatch) => {
  dispatch({
    type: SET_PAYMENT_DATA,
    payload: data,
  })
}

export const clearPaymentData = () => async (dispatch) => {
  dispatch({
    type: CLEAR_PAYMENT_DATA,
  })
}

export const sendPayment = () => async (dispatch, getStore) => {
  const { paymentData, tableOptions } = getStore().ReferralReport
  const { userId } = getStore().auth.user
  const { id, paymentDate, ...rest } = paymentData
  const formattedPaymentData = {
    ...rest,
    paymentDate: new Date(paymentDate),
    paymentEnteredBy: userId,
  }

  let isEnteredMap = new Map()
  isEnteredMap.set('paymentDate', { value: 'Payment Date', id: 0 })
  isEnteredMap.set('paymentAmount', { value: 'Payment Amount', id: 1 })
  isEnteredMap.set('payee', { value: 'Payee', id: 2 })

  Object.keys(paymentData).forEach((key) => {
    if (paymentData[key]) {
      isEnteredMap.delete(key)
    }
  })

  let validate = ''

  isEnteredMap.forEach((value) => {
    if (value.id >= isEnteredMap.size - 1) {
      validate += value.value + ' '
    } else {
      validate += value.value + ', '
    }
  })
  if (validate) {
    return notificationDangerCustomTime(`You must enter data for ${validate} to be able to mark as read`, 10000)
  }

  console.log('[PAYMENT DATA] => ', formattedPaymentData)
  await axios.patch(`/referral/mark-as-read/${id}`, { ...formattedPaymentData, paymentStatus: 'Paid' })
  dispatch(getReferalTableData(tableOptions))
}

export const updateAttentionTo = (id, assigned, deleteAssigned, contactIdTask) => async () => {
  await axios.patch('/referral/update-attention-to', { id, attention: assigned, deleteAssigned, contactIdTask })
}
